<div class="banners">
  <owl-carousel-o [options]="bannerOptions">
    <ng-container *ngFor="let banner of banners">
      <ng-template carouselSlide>
        <div class="banner">
          <a [href]="banner.url" target="_blank" [title]="banner.title">
            <img [src]="banner.files[0].url" loading="lazy">
          </a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>